var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vb-datepicker',{ref:"datepicker",attrs:{"value":_vm.value,"type":"month","placeholder":_vm.placeholder},on:{"blur":_vm.onBlur,"month-selected":_vm.onMonthSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }